// extracted by mini-css-extract-plugin
module.exports = {"form":"formStyle_form__3JQXj","button":"formStyle_button__2ZnR9","tos":"formStyle_tos__2JA3U"};